export default "__VITE_ASSET__B8Xl_ytH__"